import React from 'react'
import { HighlightList, PageSection as Section } from '@superhi/design'

const DATA: React.ComponentProps<typeof HighlightList>['children'] = [
  'Online events and workshops on design and code, available live and on-demand',
  'A range of creative briefs to keep your creativity flowing and bolster your portfolio',
  'Upgraded peer mentorship program to help you level-up your career in a focused way',
  'Member feedback channel for you to shape SuperHi’s ongoing experience',
  'Office Hours with SuperHi team members to answer your questions',
  'Members-only technical content that builds on skills taught in our courses',
]

const ComingSoon: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Section
    title="Coming soon"
    subtitle="These are just some of the exciting things we have in the pipeline. They’ll always be free to members."
    // collapseBottomPadding
    headingLevel={2}
  >
    <HighlightList>{DATA}</HighlightList>
  </Section>
)

export default ComingSoon
